export default __webpack_public_path__ + "static/media/rack4.75023f3a.webp";